/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_File_Tree_SelectedInputs */

const es_components_file_tree_selected = /** @type {(inputs: Components_File_Tree_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`seleccionados`)
};

const en_components_file_tree_selected = /** @type {(inputs: Components_File_Tree_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`selected`)
};

/**
* | output |
* | --- |
* | "selected" |
*
* @param {Components_File_Tree_SelectedInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_file_tree_selected = /** @type {((inputs?: Components_File_Tree_SelectedInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_File_Tree_SelectedInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_file_tree_selected(inputs)
	return en_components_file_tree_selected(inputs)
});
export { components_file_tree_selected as "components.file_tree.selected" }